module.exports = __webpack_public_path__ + "img/schnittkante_signalgelb_ral1003.869e2798.jpg";